// extracted by mini-css-extract-plugin
export var skipAnimation = "_1a-0";